import { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import EnrollmentDetailsPage from './EnrollmentDetailsPage';
import EnrollmentReportPage from './EnrollmentReportPage';  

function EnrollmentDetailsTab() {
  const [value, setValue] = useState(0);

  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="dashboard tabs"
        sx={{ mb: 2 }}
      >
        <Tab label="Detalles" />
        <Tab label="Reporte" />
      </Tabs>


      {value === 0 && (
        <Box>
          <EnrollmentDetailsPage />
        </Box>
      )}

      {value === 1 && (
        <Box>
         <EnrollmentReportPage />
        </Box>
      )}
    </Box>
  );
}

export default EnrollmentDetailsTab;
